import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const trialGroupLaboratoryFinanceApi = {
    getTrialGroupLaboratoryFinanceByTrialGroupLaboratoryId: (trialGroupLaboratoryId: number): Observable<Dtos.GetTrialGroupLaboratoryFinanceByTrialGroupLaboratoryIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialGroupLaboratoryFinanceByTrialGroupLaboratoryId = new Dtos.GetTrialGroupLaboratoryFinanceByTrialGroupLaboratoryId();
        request.trialGroupLaboratoryId = trialGroupLaboratoryId;

        //Send request.
        const response: Promise<Dtos.GetTrialGroupLaboratoryFinanceByTrialGroupLaboratoryIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialGroupLaboratoryFinanceById: (id: number): Observable<Dtos.GetTrialGroupLaboratoryFinanceByIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialGroupLaboratoryFinanceById = new Dtos.GetTrialGroupLaboratoryFinanceById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetTrialGroupLaboratoryFinanceByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setTrialGroupLaboratoryFinance: (trialGroupLaboratoryFinance: Dtos.TrialGroupLaboratoryFinance): Observable<Dtos.SetTrialGroupLaboratoryFinanceResponse> => {

        let request: Dtos.SetTrialGroupLaboratoryFinance = new Dtos.SetTrialGroupLaboratoryFinance();

        request.trialGroupLaboratoryFinance = trialGroupLaboratoryFinance;

        // send request
        const response: Promise<Dtos.SetTrialGroupLaboratoryFinanceResponse> = client.post(request);

        return Observable.from(response);
    },
    createTrialGroupLaboratoryFinance: (trialGroupLaboratoryId: number): Observable<Dtos.CreateTrialGroupLaboratoryFinanceResponse> => {
        //Create the request.
        let request: Dtos.CreateTrialGroupLaboratoryFinance = new Dtos.CreateTrialGroupLaboratoryFinance();

        request.trialGroupLaboratoryId = trialGroupLaboratoryId;

        //Send request.
        const response: Promise<Dtos.CreateTrialGroupLaboratoryFinanceResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateTrialGroupLaboratoryFinance: (trialGroupLaboratoryFinance: Dtos.TrialGroupLaboratoryFinance): Observable<Dtos.ValidateTrialGroupLaboratoryFinanceResponse> => {

        let request: Dtos.ValidateTrialGroupLaboratoryFinance = new Dtos.ValidateTrialGroupLaboratoryFinance();

        request.trialGroupLaboratoryFinance = trialGroupLaboratoryFinance;

        // send request
        const response: Promise<Dtos.ValidateTrialGroupLaboratoryFinanceResponse> = client.post(request);

        return Observable.from(response);
    },
}